/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import * as blastAnimation from '../../home/icons/blast.json';
import { HeaderContext } from '../../../contexts/headerContext';
import nextArrow from '../../../../public/assets/next-arrow.svg';
import next from '../../../../public/assets/next.svg';
import location from '../../../../public/assets/location.svg';
import { getCurrentOrganization } from '../../../utils/helpers';
import crossIcon from '../../home/icons/cross.svg';

const LottieIcon = dynamic(() => import('../LottieIcon'), { ssr: false });

function SuccessFormPopup({
  isOpen,
  onClose,
  title,
  message,
  type = '1',
  isPageNotRedirect = false,
  pageType,
  redirectionLink,
  redirectionText = '',
  date,
  time,
  mode,
  center,
}) {
  const router = useRouter();
  const { userRedirectPage } = useContext(HeaderContext);
  const { isMobile } = router.query;
  const [queryPareams] = useState({ isMobile });
  const timer = 6 * 1000;
  const formattedDate = new Date(date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const [firstLineText, secondLineText] = redirectionText.split(',');
  const domainName = getCurrentOrganization();

  const callAndroidOrIOSFunction = () => {
    // Calling the Android function from JavaScript
    // eslint-disable-next-line no-undef
    if (typeof Android !== 'undefined' && Android.profileRedirect) {
      // eslint-disable-next-line no-undef
      Android.profileRedirect('my-details'); // Android-specific function call
    }
    // Calling the iOS function from JavaScript
    if (
      window.webkit
      && window.webkit.messageHandlers
      && window.webkit.messageHandlers.callbackHandler
    ) {
      window.webkit.messageHandlers.callbackHandler.postMessage(
        'iosProfileCompleted',
      ); // iOS-specific function call
    }
  };

  const handlePopup = () => {
    if (queryPareams.isMobile) {
      setTimeout(() => {
        onClose();
        callAndroidOrIOSFunction();
      }, timer);
    } else {
      setTimeout(() => {
        onClose();
        if (!isPageNotRedirect) {
          router.push(userRedirectPage);
        }
      }, timer);
    }
  };
  useEffect(() => {
    if (title !== 'Appointment Booked') handlePopup();
  }, []);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-20 pl-3 pr-3"
      onClick={onClose}
      onKeyUp={() => onClose()}
    >
      <div className={`bg-white rounded-lg shadow-lg max-w-sm w-full text-center relative ${pageType === 'course-group' ? 'px-3 py-2' : 'p-2'}`} onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          onClick={onClose}
          className="absolute top-1 right-1  rounded hover:bg-gray-100 focus:outline-none"
          aria-label="Close"
        >
          <Image src={crossIcon} alt="Close" width={28} height={28} />
        </button>
        {type === '1' && (
          <div className="flex justify-center">
            <LottieIcon iconJson={blastAnimation} />
          </div>
        )}
        {type === '3' && (
          <div className="flex justify-center">
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28 52.5C41.531 52.5 52.5 41.531 52.5 28C52.5 14.469 41.531 3.5 28 3.5C14.469 3.5 3.5 14.469 3.5 28C3.5 41.531 14.469 52.5 28 52.5Z"
                fill="#46CC5C"
              />
              <path
                d="M24.955 36.1667C24.3436 36.1548 23.7613 35.9035 23.3333 35.4667L17.045 29.015C16.6133 28.571 16.3758 27.9737 16.3845 27.3545C16.3933 26.7353 16.6476 26.145 17.0916 25.7133C17.5357 25.2817 18.133 25.0441 18.7521 25.0529C19.3713 25.0616 19.9617 25.316 20.3933 25.76L25.06 30.5667L35.77 20.475C36.2248 20.079 36.8154 19.8745 37.4177 19.9044C38.0201 19.9342 38.5875 20.1962 39.0009 20.6353C39.4143 21.0744 39.6417 21.6565 39.6353 22.2595C39.6289 22.8626 39.3893 23.4398 38.9666 23.87L26.5883 35.5367C26.1463 35.9507 25.5605 36.1766 24.955 36.1667Z"
                fill="white"
              />
            </svg>
          </div>
        )}
        <h2 className="text-2xl font-bold mt-2">{title}</h2>
        {pageType === 'slot-booking' && (
          <p className="text-[#045692] text-md mt-1">
            {formattedDate}
            {' '}
            {domainName.organizationName !== 'nextias' && time && time !== '00:00:00' && ` | ${time}`}
          </p>
        )}
        {
          pageType === 'course-group'
          && (
          <div className=" mt-2 bg-[#015BA5] text-white p-1 py-2  rounded-md flex items-center justify-between px-2" onClick={() => router.push(redirectionLink)}>
            <p className="text-white text-[17px] cursor-pointer text-bold mb-0">
              {redirectionText}
            </p>
            <Image width={16} height={16} src={next} alt="arrow" />
          </div>
          )
        }
        {pageType === 'promotional-event' && (
          <button
            onClick={() => onClose()}
            type="button"
            className="w-full mt-2 bg-[#045692] text-white px-6 py-3 rounded-md "
          >
            OK
          </button>
        )}
        {pageType === 'requestCallback' && (
          <Link href={redirectionLink}>
            <div className="w-full mt-2 bg-[#045692] text-white p-2 rounded-md font-[600] flex items-center justify-between">
              <div>
                <p className="font-bold text-md text-left">{firstLineText}</p>
                <p className="font-medium text-sm text-left">
                  {secondLineText}
                </p>
              </div>
              <Image width={30} height={30} src={nextArrow} alt="arrow" />
            </div>
          </Link>
        )}

        <p className="font-medium mx-3 text-[13px] mt-3 mb-1 text-gray-400">{message}</p>

        {pageType === 'slot-booking' && (
          <div>
            {mode === 'Offline' && (
              <div className="w-full mt-2 border border-[#8ACEFF] p-2 rounded-md font-[600] flex flex-col items-start text-left">
                <div className="flex items-center gap-2">
                  <Image
                    src={location}
                    alt="Location Icon"
                    width={16}
                    height={16}
                  />
                  <p className="font-bold text-md">
                    {domainName.organizationName === 'nextias'
                      ? 'NEXT IAS'
                      : 'MADE EASY'}
                  </p>
                </div>
                <p className="font-medium text-sm ml-6">
                  {center}
                </p>
              </div>
            )}

            <button
              onClick={onClose}
              type="button"
              className="w-full mt-2 bg-[#045692] text-white px-6 py-3 rounded-md font-[600]"
            >
              Reschedule Booking
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SuccessFormPopup;
